let accordion = {};
let currentEle;

accordion.init = () => {
  var hash = window.location.hash;  
  if(hash){
    accordion.setActive(hash, false);
  }
  else{
    accordion.setEvent('js-accordion-header');
  }  
}

accordion.setEvent = (e) => {
  let ele = document.getElementsByClassName(e);
  if (!ele) return;
  for (let i = 0; i < ele.length; i++) {
    ele[i].id = 'jsAccordionHeader' + i;
    
    ele[i].addEventListener('click', (e) => {
      accordion.actions(e);
      // console.log(e);
    });
  }
}

//toggle action
accordion.actions = (e) => {
  if (!e) return;
  currentEle = e.target.id;
  // console.log(e);
  if (!e.target.classList.contains('is-active')) {
    e.target.classList.add('is-active');

    setTimeout(function () {
      accordion.scrollEffect(currentEle);
    }, 500);
  } else {
    e.target.classList.remove('is-active');
  }

  accordion.checker();
}

//check btn which is active
accordion.checker = () => {
  let eleBtn = document.getElementsByClassName('js-accordion-header');
  if (!eleBtn) return;

  for (let i = 0; i < eleBtn.length; i++) {
    if (eleBtn[i].id !== currentEle) {
      eleBtn[i].classList.remove('is-active');
    }

    if (i > 10000) break;
  }
}

//scroll effect on active accordion
accordion.scrollEffect = (e) => {
  let navHeight = $('.navbar').outerHeight();

  if ($('body').hasClass('admin-bar') && $('#wpadminbar')) {
    navHeight = navHeight + $('#wpadminbar').outerHeight();
  }
  
  $('html, body').animate({
    scrollTop: $('#' + e).parent().offset().top - navHeight,
  }, 500);
}


document.addEventListener('DOMContentLoaded', () => {
  accordion.init();
});

document.addEventListener('click', (e) => {
  var hash = e.target.hash; 

  if (e.target.class == "professionals" || $(e.target).parents(".professionals").length) {    
    
    if(hash){
      accordion.setActive(hash,true);
    }
    else{
      if (e.target.class == "professionals" || $(e.target).parents(".professionals").length) {
        $('#js-head').removeClass('is-open');   
      }
      accordion.setEvent('js-accordion-header');
    } 
  }
});


accordion.setActive = (hash, boolean) => {
  let navHeight = $('.navbar').outerHeight();

  var listLi = $('div.menu-wrapper ul').find('li');
  var newHash = hash.replace('#', '');

  if ($('body').hasClass('admin-bar') && $('#wpadminbar')) {
    navHeight = navHeight + $('#wpadminbar').outerHeight();
  } 

  $.each(listLi, function( index, value ) {
    var span = $(this).find('span');
    var spanData = span.data('scrollingbtn');
    
    if(newHash == spanData){
      $(this).find('a').addClass('is-active'); 

      $('html, body').animate({
        scrollTop: $('#'+newHash).offset().top - navHeight,
      }, 500);      

      if(boolean == true){
        $('#js-head').removeClass('is-open');        
      }
    }
    else{
      $(this).find('a').removeClass('is-active'); 
    }
  });
}




// WEBPACK FOOTER //
// ./scripts/components/accordion.js